import styled from 'styled-components';
import { Text } from '~/components/ui/Text';
import { DialogueReplyIcon } from '~/shared';
import { buttonColors } from './Button.model';

const StyledIcon = styled.div<{
	$icon: string | null;
	$type: DialogueReplyIcon;
}>`
	width: 16px;
	height: 16px;
	mask-image: url(${(props) => props.$icon});
	mask-position: center;
	mask-repeat: no-repeat;
	mask-size: contain;
	-webkit-mask-image: url(${(props) => props.$icon});
	-webkit-mask-position: center;
	-webkit-mask-repeat: no-repeat;
	-webkit-mask-size: contain;
	background-color: ${(props) => buttonColors[props.$type].normal.text};
	transition: background-color 0.3s ease;
`;

const StyledButton = styled.div<{ $type: DialogueReplyIcon; $span?: number }>`
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0 20px;
	height: 60px;
	border-radius: 10px;
	cursor: pointer;
	background-color: ${(props) => buttonColors[props.$type].normal.bg};
	border: 1px solid
		${(props) => buttonColors[props.$type].normal.border || 'transparent'};
	transition: background-color 0.3s ease;
	grid-column: ${(props) => (props.$span ? `span ${props.$span}` : 'auto')};

	${Text} {
		font-weight: 400;
		font-size: 16px;
		color: ${(props) => buttonColors[props.$type].normal.text};
		transition: color 0.3s ease;
	}

	&:hover {
		background-color: ${(props) => buttonColors[props.$type].hover.bg};

		${Text} {
			color: ${(props) => buttonColors[props.$type].hover.text};
		}

		${StyledIcon} {
			background-color: ${(props) => buttonColors[props.$type].hover.text};
		}
	}
`;

export { StyledButton, StyledIcon };
